<template>
  <div class="account-custom-datetimerange-container">
    <div class="wrap" style="display: flex">
      <div class="type" style="display: flex">
        <div :class="{item: true, active: activeTimeType === 0}" @click="activeTimeType = 0">昨天</div>
        <div :class="{item: true, active: activeTimeType === 1}" @click="activeTimeType = 1">上周</div>
        <div :class="{item: true, active: activeTimeType === 2}" @click="activeTimeType = 2">上个月</div>
      </div>
      <el-date-picker
        v-model="dateTimeRange"
        :picker-options="pickerOptions"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy-MM-dd"
        :clearable='false'
        @change="changeTime"
        size="small"
        align="right">
      </el-date-picker>
    </div>
  </div>
</template>
<script>
import {
  getTodayStartTimestamp, getTodayEndTimestampLast, getLastWeek, getLastMonth,
} from '@/utils/index';

export default {
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dateTimeRange: [],
      activeTimeType: this.type,
      pickerOptions: {
        disabledDate(time) {
          // 日期只能选择100天前到今天的日期
          const curDate = (new Date()).getTime();
          const three = 100 * 24 * 3600 * 1000;
          const threeMonths = curDate - three;
          return time.getTime() > getTodayEndTimestampLast() - 24 * 60 * 60 * 1000 || time.getTime() < threeMonths;
        },
      },
    };
  },
  watch: {
    dateTimeRange(newV) {
      let selectedDateArr = [];
      if (!newV) {
        selectedDateArr = [];
      } else {
        selectedDateArr = newV;
      }
      this.$emit('change', selectedDateArr);
    },
    activeTimeType(type) {
      this.changeDateTimeRange(type);
      // 需要在change事件之后执行
      this.$nextTick(() => {
        this.$emit("typeChange");
      });
    },
  },
  methods: {
    changeDateTimeRange(type) {
      if (type === 0) {
        this.dateTimeRange = [
          getTodayStartTimestamp() - 24 * 60 * 60 * 1000,
          getTodayEndTimestampLast() - 24 * 60 * 60 * 1000,
        ];
      } else if (type === 1) {
        const result = getLastWeek();

        this.dateTimeRange = [result.startDate, result.endDate];
      } else if (type === 2) {
        const result = getLastMonth();
        this.dateTimeRange = [result.startDate, result.endDate];
      }
    },
    changeTime() {
      this.activeTimeType = -1;
    },
  },
  created() {
    this.changeDateTimeRange(0);
  },
};
</script>
<style lang="scss">
.account-custom-datetimerange-container {
  > .wrap {
    > .type {
      .item {
        font-size: 14px;
        width: 100px;
        min-width: 100px;
        margin-right: 14px;
        flex: 1;
        height: 32px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
        border: 1px solid #DDE0E7;
        color: #5E5E63;
        &.active {
          border: 1px solid #008CFF;
          color: #008CFF;
        }
      }
    }
  }
}
</style>
